import * as RadixTabs from "@radix-ui/react-tabs";
import type { ReactNode } from "react";

import { cn } from "./cn";
import {
  segmentedItemClassName,
  segmentedTrackClassName,
} from "./segmentedStyles";

export interface TabItem {
  value: string;
  label: string;
  content: ReactNode;
}

export function Tabs({
  items,
  value,
  onValueChange,
  label,
  trailing,
}: {
  items: TabItem[];
  value?: string;
  onValueChange?: (value: string) => void;
  label: string;
  /** Right-aligned content in the tab strip row (e.g. header actions). */
  trailing?: ReactNode;
}) {
  return (
    <RadixTabs.Root
      value={value}
      onValueChange={onValueChange}
      defaultValue={items[0]?.value}
    >
      <div className="flex items-center gap-2">
        <RadixTabs.List
          aria-label={label}
          className={cn(segmentedTrackClassName, "flex-1")}
        >
          {items.map((item) => (
            <RadixTabs.Trigger
              key={item.value}
              value={item.value}
              className={cn(
                segmentedItemClassName,
                "data-[state=active]:bg-raised data-[state=active]:text-fg data-[state=active]:shadow-card",
              )}
            >
              {item.label}
            </RadixTabs.Trigger>
          ))}
        </RadixTabs.List>
        {trailing}
      </div>
      {items.map((item) => (
        <RadixTabs.Content key={item.value} value={item.value} className="pt-3">
          {item.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
